<template>
  <el-form
    ref="feesForSecurityMasterForm"
    :model="model"
    :rules="rules"
    label-width="11.5em"
    label-position="left"
    class="fees-for-security-master-form"
  >
    <div class="el-form--inline">
    <ChargeYear v-model="chargeYear" label="料金年度"  prop="charge_year" yearType = "reference"  :required="true" :searchCond="true" :disabled="editMode" :autofocus="!editMode" :initialize="true" :tableType = tableType mode = "this" />
    <!-- <BillingYm v-model="billingYm" :required="true" :searchCond="true" :mode="billingYmMode" :disabled="editMode" :autofocus="!editMode" /> -->
    <Select v-model="routeCode" label="線別" prop="route_code" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" codeId="ROUTE_CODE" :initialize="true" />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <Numeric v-model="passengerCharge" label="旅客単価" prop="passenger_charge"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :step="1" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="cargoCharge" label="貨物単価" prop="cargo_charge"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :step="1" :disabled="editDisabledMode && editMode" />
    </div>
    <template v-if='formMode === "edit" '>
      <el-divider />
      <div class="el-form--inline">
        <DateTime v-model="updatedOn" label="更新日時" prop="updated_on"
            :required="!searchMode" :searchCond="searchMode" :disabled="editMode"
            format="yyyy/MM/dd HH:mm:ss" />
        <Blank />
      </div>
    </template>
    <el-divider />
  </el-form>
</template>

<script>
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'
import Select from '@/components/molecules/form/select/Select.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'

export default {
  components: {
    ChargeYear,
    Select,
    Numeric,
    DateTime,
    Blank
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    // billingYmMode: {
    //   type: String,
    //   default: 'search'
    // },
    editDisabledMode: {
      type: Boolean,
      default: false
    },
    tableType: String
  },
  data () {
    return {}
  },
  computed: {
    chargeYear: {
      get () {
        return this.model.charge_year
      },
      set (chargeYear) {
        const form = { ...this.model }
        form.charge_year = chargeYear
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    passengerCharge: {
      get () {
        return this.model.passenger_charge
      },
      set (passengerCharge) {
        const form = { ...this.model }
        form.passenger_charge = passengerCharge
        this.$emit('input', form)
      }
    },
    cargoCharge: {
      get () {
        return this.model.cargo_charge
      },
      set (cargoCharge) {
        const form = { ...this.model }
        form.cargo_charge = cargoCharge
        this.$emit('input', form)
      }
    },
    updatedOn: {
      get () {
        return this.model.updated_on
      },
      set (updatedOn) {
        const form = { ...this.model }
        form.updated_on = updatedOn
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
    // editDisabledMode: {
    //   get () {
    //     return this.model.regist_type === '1' || parseInt(this.model.billing_ym) < parseInt(this.getDefaultBillingYm())
    //   }
    // }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.feesForSecurityMasterForm.resetFields()
      // this.billingYm = this.getDefaultBillingYm()
      // if (this.searchMode) {
      //   this.model.manual_data_only = false
      //   this.model.automatic_data_only = false
      // }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.feesForSecurityMasterForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fees-for-security-master-form {
  .el-form--inline {
    display: flex;
    justify-content: space-between;
    // margin-left: 10px;
  }
  .el-form-item {
    width: 60em;
  }
  // ::v-deep .el-form-item__content .el-input__inner {
  //   width: 12em;
  // }
  .parent_Box{
    padding-right: 15px
  }
}

</style>
